// import React, { useEffect } from "react";
// import Modal from "react-bootstrap/Modal";
// import { API_ENDPOINTS } from "../../../constant/_constant";
// import usePostRequest from "../../../hooks/usePostRequest";
// import moment from "moment";
// import { IconCalendarWeekFilled, IconMailSpark } from "@tabler/icons-react";
// import Lottie from "lottie-react";
// import notfoundData from "../../../assets/not_found.json";
// import {
//   Button,
//   Table,
//   Card,
//   Col,
//   Form,
//   Row,
//   InputGroup,
//   FormText,
//   textarea,
//   Tab,
//   Tabs,
//   Spinner,
//   ButtonGroup,
// } from "react-bootstrap";
// function EmailHistoryOrder({ setShow, show, order_id }) {
//   const {
//     data: EmailHISTORY_DATA,
//     isLoading: EmailHISTORY_LOADING,
//     postData: fetchEmails,
//   } = usePostRequest(API_ENDPOINTS.EMAIL_HISTORY_ORDER);

//   useEffect(() => {
//     fetchEmails({ order_id: order_id });
//   }, []);

//   return (
//     <Modal
//       scrollable={true}
//       show={show}
//       onHide={() => setShow({ show: false })}
//       dialogClassName="modal-90w"
//       size="lg"
//       aria-labelledby="example-custom-modal-styling-title"
//     >
//       <Modal.Header className="gap-2" closeButton>
//         <span className="avatar bg-orange-lt rounded-circle">
//           <IconMailSpark stroke={1.25} />
//         </span>
//         <div>
//           <Modal.Title>Email History</Modal.Title>
//         </div>
//       </Modal.Header>
//       <Modal.Body>
//         {EmailHISTORY_DATA && EmailHISTORY_DATA.data.length > 0 ? (
//           EmailHISTORY_DATA?.data.map((item, index) => {
//             return (
//               <>
//                 <div className="mail_wrapper" key={index}>
//                   <Row>
//                     <Col md={6}>
//                       <div className="mail_head_item">
//                         <p className="mb-0">
//                           <strong>Quote No:</strong> {order_id}
//                         </p>
//                         <p className="mb-0">
//                           <strong>Sent To:</strong> {item?.to_email}
//                         </p>
//                       </div>
//                     </Col>
//                     <Col md={6}>
//                       <div className="mail_head_item">
//                         <p className="mb-0 text-end d-flex align-items-center gap-1 justify-content-end">
//                           <IconCalendarWeekFilled stroke={1} width={20} />{" "}
//                           {moment(item?.latest_date).format("MM/DD/YYYY")}
//                         </p>
//                         <p className="mb-0 text-end">
//                           <strong>From: </strong> {item?.from_email}
//                         </p>
//                       </div>
//                     </Col>
//                   </Row>
//                   <hr />

//                   <p
//                     style={{ borderTop: "solid 1px #ddd;" }}
//                     dangerouslySetInnerHTML={{
//                       __html: item?.body || "",
//                     }}
//                   ></p>
//                   <Row>
//                     {item?.sku_data && (
//                       <div className="table-responsive">
//                         <Table bordered>
//                           <thead>
//                             <tr>
//                               <th> Vendor/Partner</th>
//                               <th> SKU ID</th>
//                               <th> SKU Desc</th>
//                               <th> QTY</th>
//                               <th> Unit Cost($)</th>
//                               <th> Total Cost($)</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {item?.sku_data.map((P, index) => (
//                               <tr key={index}>
//                                 <td>{P?.Vendor?.display_name}</td>
//                                 <td>{P?.sku_id}</td>
//                                 <td>{P.description}</td>
//                                 <td>{P.quantity}</td>
//                                 <td>
//                                   {Number(P.customer_price).toLocaleString(
//                                     "en-US",
//                                     {
//                                       minimumFractionDigits: 2,
//                                       maximumFractionDigits: 2,
//                                     }
//                                   )}
//                                 </td>
//                                 <td>
//                                   {Number(P.total_price).toLocaleString(
//                                     "en-US",
//                                     {
//                                       minimumFractionDigits: 2,
//                                       maximumFractionDigits: 2,
//                                     }
//                                   )}
//                                 </td>
//                               </tr>
//                             ))}
//                             <tr>
//                               <td colSpan={4}></td>
//                               <td>
//                                 <strong>SUB TOTAL</strong>
//                               </td>
//                               <td>
//                                 <strong>
//                                   $
//                                   {item.sku_data
//                                     ?.reduce(
//                                       (total, current) =>
//                                         total + Number(current.total_price),
//                                       0
//                                     )
//                                     .toFixed(2)}
//                                 </strong>
//                               </td>
//                             </tr>
//                           </tbody>
//                         </Table>
//                       </div>
//                     )}
//                   </Row>
//                 </div>
//               </>
//             );
//           })
//         ) : (
//           <div className="data_not_available text-center pb-4">
//             {" "}
//             <Lottie animationData={notfoundData} /> <p> No History Available</p>{" "}
//           </div>
//         )}
//       </Modal.Body>
//     </Modal>
//   );
// }

// export default EmailHistoryOrder;

import React, { useEffect, useState, useRef } from "react";
import {
  IconId,
  IconMailForward,
  IconMail,
  IconFileText,
  IconCalendarWeekFilled,
} from "@tabler/icons-react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import moment from "moment";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import {
  Button,
  Table,
  Col,
  Form,
  Row,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import Lottie from "lottie-react";
import notfoundData from "../../../assets/not_found.json";
import Stepper from "../../../components/Stepper";
import { trimTrailingZeros } from "../../../utils/_helpers";

function EmailHistoryOrder({
  username,
  rma_id,
  show,
  setShow,
  setIsSuccsessModalOpen,
}) {
  // Stepper State
  const [currentStep, setCurrentStep] = useState(1);
  const stepOptions = ["Email History", "Send Email"];
  const handleTabClick = (step) => setCurrentStep(step);

  // Email History
  const {
    data: EmailHISTORY_DATA,
    isLoading: EmailHISTORY_LOADING,
    postData: fetchEmails,
  } = usePostRequest(API_ENDPOINTS.EMAIL_HISTORY_RMA);

  // Email Form
  const { data: EmailUSerData, postData: fetchUserEmails } = usePostRequest(
    API_ENDPOINTS.EMAIL_ALL_USERS
  );

  const { isLoading: sendLoading, postData: SendOrderEmail } = usePostRequest(
    API_ENDPOINTS.SEND_RMA_EMAIL
  );

  const formRef = useRef(null);
  const [errors, setErrors] = useState({ comment: "", to_email: "" });
  const [emailData, setEmailData] = useState({
    rma_id: rma_id || "",
    to_username: username || "",
    to_email: "",
    comment: "",
  });

  const validateComment = (comment) =>
    comment.trim() === "" ? "Comment is required." : "";

  const handleCommentChange = (e) => {
    const comment = e.target.value;
    setErrors((prev) => ({ ...prev, comment: validateComment(comment) }));
    setEmailData((prev) => ({ ...prev, comment }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const commentError = validateComment(emailData.comment);
    const emailError = emailData.to_email ? "" : "Please select a user.";

    if (commentError || emailError) {
      setErrors({ comment: commentError, to_email: emailError });
      return;
    }

    SendOrderEmail(emailData, onSuccess, onError);
  };

  const onSuccess = (res) => {
    setIsSuccsessModalOpen({
      show: true,
      title: "Success",
      message: "Email Sent Successfully!",
      btntext: "Close",
    });
    setShow({ show: false });
  };

  const onError = (error) => toast.error(error?.message);

  const handleCancel = () => {
    setEmailData({
      comment: "",
      to_email: "",
      rma_id: rma_id || "",
      to_username: username || "",
    });
    setErrors({ comment: "", to_email: "" });
    setShow({ show: false });
  };

  useEffect(() => {
    fetchEmails({ rma_id });
    fetchUserEmails();
  }, [rma_id]);

  return (
    <Modal
      scrollable
      show={show}
      onHide={() => setShow({ show: false })}
      dialogClassName="modal-90w"
      size="lg"
    >
      {/* <Modal.Header closeButton className="gap-2">
        <span className="avatar bg-orange-lt rounded-circle">
          <IconMail stroke={1.25} />
        </span>
        <div>
          <Modal.Title>Email Actions</Modal.Title>
        </div>
      </Modal.Header> */}

      <Modal.Body>
        <Stepper
          steps={stepOptions}
          currentStep={currentStep}
          onTabClick={handleTabClick}
        />
        <hr className="mb-4" />

        {/* Step 1: Email History */}
        {currentStep === 1 && (
          <>
            {EmailHISTORY_LOADING ? (
              <div className="text-center py-5">
                <Spinner animation="border" />
              </div>
            ) : EmailHISTORY_DATA?.data?.length > 0 ? (
              EmailHISTORY_DATA?.data.map((item, index) => (
                <div className="mail_wrapper mb-4" key={index}>
                  <Row>
                    <Col md={6}>
                      <div className="mail_head_item">
                        <p className="mb-0">
                          <strong>Quote No:</strong> {rma_id}
                        </p>
                        <p className="mb-0">
                          <strong>Sent To:</strong> {item?.to_email}
                        </p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mail_head_item text-end">
                        <p className="mb-0 d-flex align-items-center justify-content-end gap-1">
                          <IconCalendarWeekFilled stroke={1} width={20} />
                          {moment(item?.latest_date).format("MM/DD/YYYY")}
                        </p>
                        <p className="mb-0">
                          <strong>From:</strong> {item?.from_email}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <hr />
                  <p dangerouslySetInnerHTML={{ __html: item?.body || "" }}></p>

                  {item?.sku_data && (
                    <div className="table-responsive mt-3">
                      <Table bordered>
                        <thead>
                          <tr>
                            <th>Vendor/Partner</th>
                            <th>SKU ID</th>
                            <th>SKU Desc</th>
                            <th>QTY</th>
                            <th>Unit Cost($)</th>
                            <th>Total Cost($)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item?.sku_data.map((P, i) => (
                            <tr key={i}>
                              <td>{P?.Vendor?.display_name}</td>
                              <td>{P?.sku_id}</td>
                              <td>{P.description}</td>
                              <td>{trimTrailingZeros(P.quantity)}</td>
                              <td>
                                {Number(P.customer_price).toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                              <td>
                                {Number(P.total_price).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td colSpan={4}></td>
                            <td>
                              <strong>SUB TOTAL</strong>
                            </td>
                            <td>
                              <strong>
                                $
                                {item.sku_data
                                  ?.reduce(
                                    (total, curr) =>
                                      total + Number(curr.total_price),
                                    0
                                  )}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="data_not_available text-center pb-4">
                <Lottie animationData={notfoundData} />
                <p>No History Available</p>
              </div>
            )}
          </>
        )}

        {/* Step 2: Send Email */}
        {currentStep === 2 && (
          <Form onSubmit={handleSubmit} ref={formRef}>
            <Form.Group className="mb-3">
              <Form.Label>RMA ID</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconId stroke={1} />
                </InputGroup.Text>
                <Form.Control value={emailData.rma_id} disabled />
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Select User Email ID</Form.Label>
              <Form.Select
                value={emailData.to_email}
                onChange={(e) =>
                  setEmailData({ ...emailData, to_email: e.target.value })
                }
                isInvalid={!!errors.to_email}
              >
                <option value="">Select User Email</option>
                {EmailUSerData?.data?.map((user, idx) => (
                  <option key={idx} value={user.email}>
                    {user.email}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.to_email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Comments</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconFileText />
                </InputGroup.Text>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={emailData.comment}
                  onChange={handleCommentChange}
                  isInvalid={!!errors.comment}
                  placeholder="Enter your comment..."
                />
              </InputGroup>
              <Form.Control.Feedback type="invalid">
                {errors.comment}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        )}
      </Modal.Body>

      {currentStep === 2 && (
        <Modal.Footer>
          <Button
            variant="warning"
            style={{ marginTop: "20px" }}
            onClick={() => formRef.current?.requestSubmit()}
          >
            {sendLoading ? (
              <Spinner as="span" size="sm" role="status" />
            ) : (
              "Submit"
            )}
          </Button>

          <Button
            variant="outline-danger"
            style={{ marginTop: "20px" }}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default EmailHistoryOrder;
